import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <span className="font-display text-2xl text-primary-400">新新漫画</span>
            <p className="mt-3 text-foreground-300 text-sm leading-relaxed">
              {siteInfo.description}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              <Link to="/category/hanman" className="hover:text-primary-400 transition-colors cursor-pointer">热门分类</Link>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-300 hover:text-primary-400 text-sm transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              <Link to="/about" className="hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-foreground-300 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-300 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                  联系我们
                </Link>
              </li>
              <li>
                <Link to="/" className="text-foreground-300 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                  最新推荐
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-foreground-300 text-sm">
                <i className="ri-mail-line text-primary-400" />
                <span>{siteInfo.contact.email}</span>
              </li>
              <li className="flex items-center gap-2 text-foreground-300 text-sm">
                <i className="ri-wechat-line text-primary-400" />
                <span>微信：{siteInfo.contact.wechat}</span>
              </li>
              <li className="flex items-start gap-2 text-foreground-300 text-sm">
                <i className="ri-map-pin-line text-primary-400 mt-0.5" />
                <span>{siteInfo.contact.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">
            &copy; {new Date().getFullYear()} {siteInfo.name} - 版权所有 | 韩漫日漫国漫大全
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors text-xs cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors text-xs cursor-pointer" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}